/**
 * Demonstrates how to compress the distance between characters for certain elements
 *
 * Some useful links for working with themes can be found at:
 * https://themes.material-ui.com/
 * https://material-ui.com/customization/default-theme/ //Will show all the properties you can edit
 * https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=c24f00&secondary.color=214563 //great for color selecting
 */


import { ThemeOptions } from '@material-ui/core';
import { defaultTheme, AlmeTheme } from '../../../models/AlmeTheme';


const typography = {
    // This was added for the header (with the X and _ buttons) in iPhone 5
    // SE. It applies to other mobile devices in Portrait orientation. This
    // will affect other headings, so it may need to be moved in the future.
    h6: {
        [defaultTheme.breakpoints.down('xs')]: {
            letterSpacing: "-0.1em", //This adjust the letter spacing of the "Intelligent Virutal Assistant" in the demo IVA.

        },
    },
    subtitle1: {
        letterSpacing: "-0.1em",
    },
    body1: {
        letterSpacing: "-0.1em",
    },
};


const lightModeTheme = { typography } as ThemeOptions;


export const appThemeMain = {
    lightTheme: lightModeTheme,
    darkTheme: {},
} as AlmeTheme;
